module.exports = __webpack_public_path__ + "img/btn_google_signin_dark_pressed_web.d88019ea.png";